import { type Theme } from 'theme-ui';

//  tweaks for the vaporwave theme
const theme: Theme = {
    styles: {
        root: {
            backgroundColor: ['white', 'background'],
        },
    },
    cards: {
        outer: {
            // remove card shadow on smaller screens. main -> card frame
            '& > div': {
                boxShadow: ['none', 3],
            },
            '& > div:hover': {
                boxShadow: ['none', 3],
            },
        },
    },
};

export default theme;
